<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router'
import { Lock } from '@element-plus/icons-vue'
import { watch } from 'vue'
import Header from './components/header/Header.vue'
import { useDark } from '@vueuse/core'
import { useAuthStore } from '@/stores/auth/Auth'
import { ElMessageBox } from 'element-plus'
import { storeToRefs } from 'pinia'

import SideBar from '@/components/navigation/SideBar.vue'
import MobileMenu from '@/components/navigation/MobileMenu.vue'
import { useLayoutPreferencesStore } from '@/stores/layout/layoutPreferences'
import { useI18n } from 'vue-i18n'
import { useIsActiveRoute } from '@/composables/useIsActiveRoute'
import { ERouteName } from '@/router/ERouteName'
import { useIsDesktop } from '@/composables/useIsDesktop'

const layoutPreferences = useLayoutPreferencesStore()
const authStore = useAuthStore()
const { lockedDown, sessionActive } = storeToRefs(authStore)
const { isDarkMode } = storeToRefs(layoutPreferences)
const isDark = useDark()
const { t } = useI18n()
const route = useRoute()
const isDesktop = useIsDesktop()

const narrowRouterView = new Set([
    ERouteName.CAMPAIGN_DATA,
    ERouteName.CAMPAIGN_DRAW,
    ERouteName.CAMPAIGN_PRIZE,
    ERouteName.CAMPAIGN_PROMO_PRODUCTS,
    ERouteName.CAMPAIGN_EMAILS,
    ERouteName.CAMPAIGN_FAQ,
    ERouteName.CAMPAIGN_TEAM,
    ERouteName.HIVE_EDIT,
    ERouteName.HIVE_CAMPAIGN_EDIT,
    ERouteName.SETTINGS_ACCOUNT,
    ERouteName.SETTINGS_ORGANIZATION,
    ERouteName.SETTINGS_MEMBERS
])

const { isActive } = useIsActiveRoute(narrowRouterView)

const narrowRouterViewStyle = {
    width: '100%',
    maxWidth: '800px',
    marginLeft: 'auto',
    marginRight: 'auto'
}

//Set the default state
isDark.value = isDarkMode.value
//Update State changes
watch(isDarkMode, (val) => {
    isDark.value = val
})

watch(lockedDown, () => {
    if (lockedDown) {
        ElMessageBox.close()
        ElMessageBox.confirm(
            t('settings.sessionExpiredSoon'),
            t('settings.sessionExpiredSoonMessage'),
            {
                confirmButtonText: t('settings.stayLoggedIn'),
                cancelButtonText: t('settings.logout'),
                type: 'info',
                showClose: false,
                icon: Lock
            }
        )
            .then(() => {
                authStore.refreshToken(10)
            })
            .catch(() => {
                authStore.logout()
            })
    }
})

watch(sessionActive, () => {
    if (!sessionActive) {
        ElMessageBox.close()
        ElMessageBox.confirm(t('settings.sessionExpired'), t('settings.sessionExpiredMessage'), {
            confirmButtonText: t('settings.relogin'),
            cancelButtonText: t('settings.logout'),
            type: 'info',
            showClose: false,
            icon: Lock
        })
            .then(() => {
                console.log('Refresh session!')
                location.reload()
            })
            .catch(() => {
                console.log('Error')
                authStore.logout()
            })
    }
})
</script>

<template>
    <div class="common-layout" :class="{ 'has-mobile-menu': !isDesktop }">
        <el-container>
            <SideBar />
            <el-container>
                <Header />

                <el-main
                    :style="
                        isActive || route.meta.siteContainerSite == 'small'
                            ? narrowRouterViewStyle
                            : {}
                    "
                >
                    <RouterView />
                </el-main>
            </el-container>
        </el-container>
        <MobileMenu v-if="!isDesktop" />
    </div>
</template>

<style scoped lang="scss">
.has-mobile-menu :deep(.el-main) {
    padding-bottom: calc(84px + env(safe-area-inset-bottom));
}
</style>
